import {createSelector} from 'reselect';
import authSelectors from 'src/modules/auth/authSelectors';
import PermissionChecker from 'src/modules/auth/permissionChecker';
import Permissions from 'src/security/permissions';
import Roles from 'src/security/roles';

export function tenantUserHasDataPermissionPrefix(currentUser, currentTenant, prefix?: string) {
  if (!prefix || !currentUser?.tenants || !currentTenant?.id) {
    return false;
  }

  const tenantUser = currentUser.tenants.find((userTenant) => userTenant.tenant?.id === currentTenant.id);

  return !!tenantUser?.dataPermissions?.some(
    (permission) => typeof permission?.id === 'string' && permission.id.startsWith(prefix),
  );
}

const selectPermissionToRead = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.dataRead),
);

const selectPermissionToEdit = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.dataEdit),
);

const selectPermissionToCreate = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.dataCreate),
);

const selectPermissionToImport = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.dataImport),
);

const selectPermissionToDestroy = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.dataDestroy),
);

const selectHasAdminRole = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).rolesMatchOneOf(Roles.values.dataAdmin),
);

const selectHasUserRole = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).rolesMatchOneOf(Roles.values.dataUser),
);

const dataSelectors = {
  selectHasAdminRole,
  selectHasUserRole,
  selectPermissionToRead,
  selectPermissionToEdit,
  selectPermissionToCreate,
  selectPermissionToDestroy,
  selectPermissionToImport,
};

export default dataSelectors;
